import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useMainContext } from "../../Context";
import { stracture } from "../Panel";

const Sidebar = () => {
  const { pathname } = useLocation();
  const { dispatch } = useMainContext();
  // console.log("p", pathname);
  const logout = async () => {
    dispatch("user", {});
  };
  return (
    <nav className="navbar navbar-light navbar-vertical navbar-expand-xl">
      <div className="d-flex align-items-center">
        <div className="toggle-icon-wrapper">
          <button
            className="btn navbar-toggler-humburger-icon navbar-vertical-toggle"
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            aria-label="ناوبری را تغییر دهید"
          >
            <span className="navbar-toggle-icon">
              <span className="toggle-line" />
            </span>
          </button>
        </div>
        <Link to={"/"} className="navbar-brand">
          <div className="d-flex align-items-center py-3">
            <span className="font-sans-serif">صنعتبان</span>
          </div>
        </Link>
      </div>
      <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
        <div className="navbar-vertical-content scrollbar">
          <ul className="navbar-nav flex-column mb-3" id="navbarVerticalNav">
            {stracture.pages &&
              stracture.pages.map((page, count) => {
                if (page.nested) {
                  return (
                    <li className="nav-item my-1">
                      <a
                        className="nav-link dropdown-indicator collapsed"
                        href={`#da-${count}`}
                        role="button"
                        data-bs-toggle="collapse"
                        aria-expanded="false"
                        aria-controls={`da-${count}`}
                      >
                        <div className="d-flex align-items-center">
                          <span className="nav-link-icon">
                            <i className={page.icon} />
                            {/* <span className="fas fa-chart-pie"></span> Font Awesome fontawesome.com */}
                          </span>
                          <span className="nav-link-text ps-1">
                            {page.label}
                          </span>
                        </div>
                      </a>
                      <ul className="nav collapse " id={`da-${count}`}>
                        {page.options.map(option => {
                          if (option.show) {
                            return (
                              <li className="nav-item my-1">
                                <Link
                                  className={` nav-link ${
                                    option.route == pathname && "active"
                                  }`}
                                  to={option.route}
                                  aria-expanded="false"
                                >
                                  <div className="d-flex align-items-center">
                                    <span className="nav-link-text ps-1">
                                      {option.label}
                                    </span>
                                  </div>
                                </Link>
                                {/* more inner pages*/}
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </li>
                  );
                } else {
                  return (
                    <Link
                      className="nav-link my-1"
                      to={page.route}
                      role="button"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <span className="nav-link-icon">
                          <i className={page.icon} />
                        </span>
                        <span className="nav-link-text ps-1">{page.label}</span>
                      </div>{" "}
                    </Link>
                  );
                }
              })}
            <li className="nav-link my-1"></li>
            <a
              onClick={logout}
              class="nav-link"
              role="button"
              aria-expanded="false"
            >
              <div class="d-flex align-items-center">
                <span class="nav-link-icon">
                  <i />
                </span>
                <span class="nav-link-text ps-1">خروج</span>
              </div>{" "}
            </a>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
